import { useState, useRef, useEffect } from "react";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";

const useTags = ({ search }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({ tags: [] });
  const [page, setPage] = useState(1);
  const lastSearch = useRef(search);

  useEffect(() => {
    if (search !== lastSearch.current && page !== 1) {
      setPage(1);
      return () => {};
    }

    lastSearch.current = search;
    setLoading(true);
    const abortController = new AbortController();
    caseTransformingAxios
      .get("/tags.json", { params: { page, search: search || null }, signal: abortController.signal })
      .then((res) => {
        setLoading(false);
        setData(res.data);
      })
      .catch((err) => {
        setLoading(false);
        setError(err);
      });
    return () => {
      abortController.abort();
    };
  }, [search, page]);

  return {
    actions: {
      setPage,
      saveTag: (tag) =>
        caseTransformingAxios[tag.id ? "put" : "post"](`/tags${tag.id ? `/${tag.id}` : ""}.json`, tag).then(
          (res) => {
            if (tag.id) {
              setData((prevData) => {
                const tags = prevData.tags.map((t) => (t.id === res.data.id ? res.data : t));
                return { ...prevData, tags };
              });
            } else {
              setData((prevData) => ({
                ...prevData,
                tags: [res.data, ...prevData.tags],
              }));
            }
          },
        ),
      deleteTag: (tag) =>
        caseTransformingAxios.delete(`/tags/${tag.id}.json`).then(() => {
          setData((prevData) => ({
            ...prevData,
            tags: prevData.tags.filter((t) => t.id !== tag.id),
          }));
        }),
    },
    data,
    error,
    loading,
  };
};

export default useTags;
